const zh = {
	staff: '员工',
	staffDisabled: '已禁用员工',
	name: '姓名',
	phone: '手机号',
	email: '邮箱',
	status: '状态',
	active: '启用',
	addStaff: '添加员工',
	staffList: '员工列表',
	staffAdmin: '员工管理',
};

export default zh;
